export const SIDEBAR_LOCAL_STORAGE_KEY = 'ls:run-details-sidebar';
export const TAB_PREFIX = 'run';

export const formatter = new Intl.NumberFormat('en-US', {});
export const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 20,
});
export const PERFORMANCE_PANEL_HEIGHT_OFFSET = 40;
export const LATENCY_GRAPH_HEIGHT_TOP_OFFSET = 30;

export const TREE_EXPANDED_NODE_HEIGHT = 76;
export const TREE_COLLAPSED_NODE_HEIGHT = 32;

export const GRAPH_RUN_ICON_DIMENSION = 16;
